import axios from '@/api/api.js'
const a = {
    uploadImg_dir (params, obj) {
        params.random = Math.random();
        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_upladHost + '/api/media/oss/upload?dir=' + obj.dir + '&saveFileName=' + (obj.saveFileName || ''), params).then(response => {
                // axios.post('http://192.168.0.81/api/media/upload_dir_img?dir='+obj.dir+'&saveFileName='+obj.saveFileName, params).then(response => {
                resolve(response.data);
            }).catch(err => {
                reject(err)
            })
        })
    },
}
export default a;
